/**
 * Team sector filter (default team feed)
 * Loads filtered members via admin-ajax.php
 */

document.addEventListener("DOMContentLoaded", function () {
  const filters = document.querySelector(".js-team-filters");
  const results = document.querySelector(".js-team-results");
  const filterContainer = document.querySelector(".filter-container");
  const toggleFilter = document.querySelector(".js-toggle-filter");

  if (toggleFilter && filterContainer) {
    toggleFilter.addEventListener("click", function () {
      const isOpen = filterContainer.toggleAttribute("open");
      toggleFilter.setAttribute("aria-expanded", String(isOpen));
    });
  }

  if (!filters || !results) return;

  filters.addEventListener("click", function (e) {
    const button = e.target.closest(".js-team-filter");

    if (!button || button.classList.contains("is-loading")) {
      return;
    }

    const sector = button.dataset.filter;

    filters.querySelectorAll(".js-team-filter").forEach(function (btn) {
      btn.classList.remove("active");
      btn.classList.remove("is-loading");
    });

    button.classList.add("active", "is-loading");
    results.classList.add("opacity-50", "pointer-events-none");

    const formData = new FormData();
    formData.append("action", "filter_team");
    formData.append("sector", sector);

    fetch("/wp-admin/admin-ajax.php", {
      method: "POST",
      body: formData,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (res) {
        if (res.success && res.data.html !== undefined) {
          results.innerHTML = res.data.html;
        }
      })
      .finally(function () {
        button.classList.remove("is-loading");
        results.classList.remove("opacity-50", "pointer-events-none");
      });
  });
});
